import { useLLMState } from './llm.provider'
import llmModelsData from './llm-models.json'
import Dropdown from '../../../../../@ui/form/dropdown.input'

export function LLMDropdown() {
  const llmState = useLLMState()
  const items = Object.values(llmModelsData)
    .map((provider) =>
      provider.models
        .filter((model) => !model.disabled)
        .map((model) => ({
          id: model.id,
          label: `${model.label}`,
        }))
    )
    .flat()

  return (
    <Dropdown
      items={items}
      showSearch={false}
      selected={
        items.find((item) => item.id === llmState.state.model[0])?.label ||
        llmState.state.model[0]
      }
      onSelect={(item) => {
        llmState.setState({
          model: [item.id],
        })
      }}
      useLocalFilter={true} // Default behavior
    />
  )
}
